export default "__VITE_PUBLIC_ASSET__6c965208__"